import React, { useEffect, useRef, useState } from 'react'
import logo from '../../../../icons/logo.png'
import { useNavigate, useParams } from 'react-router-dom'
// import data from '../../../../demoData/data.json'
import CustomModal from '../../../../base-components/CustomModal'
import Popup from '../../../../base-components/Popup'
import master from '../../../../icons/png-clipart-logo-mastercard-pentagram-flat-design-brand-mastercard-text-trademark.png'
import visa from '../../../../icons/png-clipart-logo-credit-card-visa-debit-card-credit-card-blue-text.png'
import paid1 from '../../../../icons/paid1.png'
import paid2 from '../../../../icons/paid2.png'
import { Button, CircularProgress } from "@mui/material"
import { IoMdPrint } from "react-icons/io";
import { useReactToPrint } from "react-to-print";
import { IoArrowBack } from "react-icons/io5";
import dayjs from 'dayjs'
import { encodedImagesURI } from '../../../../utils/helpers'
import { getSessionUser, hasPermission, isDynamicStaffRole } from '../../../../utils/roleAccess';
import { isVoucherSettled } from '../../../../utils/voucherPayment';
import { allowedVoucherPaymentMethods, defaultVoucherPaymentMethod, VOUCHER_PAYMENT_METHODS } from '../../../../utils/voucherPaymentMethods';
import BankVoucherLayout from '../../../../base-components/BankVoucherLayout';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function Voucher() {
    const { id } = useParams()
    const printRef = useRef()
    const reactToPrintFn = useReactToPrint({ contentRef: printRef });
    const navigate = useNavigate()
    const [voucher, setVoucher] = useState()
    const [member, setMember] = useState()
    const [family_members, setFamilyMembers] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isExtendModalOpen, setIsExtendModalOpen] = useState(false)
    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const [alertType, setAlertType] = useState('success')
    const [paymentData, setPaymentData] = useState({
        payment_method: 'Cash',
        payment_type: 'Paid',
        amount: 0
    })
    const [facilities, setFacilities] = useState([]);

    const [dueDate, setDueDate] = useState(null);
    const [today, setToday] = useState(null);

    const [message, setMessage] = useState('')
    const [cardName, setCardName] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [cvc, setCvc] = useState('');
    const [expiryError, setExpiryError] = useState('');
    const [cvcError, setCvcError] = useState('');
    const [member_package_amount, setMemberPackageAmount] = useState(0)
    const [packages, setPackages] = useState([])
    const [loading, setLoading] = useState(true)
    const [role, setRole] = useState('')
    const [location_id, setLocationID] = useState('')
    const [company_id, setCompanyID] = useState('')
    const [user_id, setUserId] = useState('')
    const [member_id, setMemberID] = useState('')
    const [transaction, setTransaction] = useState('')
    // const [price , setPrice] = useState([])
    const [buttonLoading, setButtonLoading] = useState(false)
    /** Prevents double-submit on Pay Voucher before React re-renders `disabled`. */
    const payVoucherSubmitLockRef = useRef(false)
    /** Stays true after a successful pay so the button cannot be used again before refresh. */
    const payVoucherCompletedRef = useRef(false)
    const [discount, setDiscount] = useState(0)
    const [discountRemarks, setDiscountRemarks] = useState('');
    const [discountError, setDiscountError] = useState('');
    const [companyData, setCompanyData] = useState(null);
    const [isDiscountModalOpen, setIsDiscountModalOpen] = useState(false);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [discountRemarksState, setDiscountRemarksState] = useState('');
    const [isSplitModalOpen, setIsSplitModalOpen] = useState(false);
    const [numberOfInstallments, setNumberOfInstallments] = useState(2);
    const [installmentDueDates, setInstallmentDueDates] = useState([]);
    const [splitDateError, setSplitDateError] = useState('');
    const [splitAmountMode, setSplitAmountMode] = useState('equal');
    const [splitCustomAmounts, setSplitCustomAmounts] = useState([]);
    const [splitAmountError, setSplitAmountError] = useState('');
    /** When list/detail voucher has subscription_id without populated dates, fetch full subscription for split. */
    const [splitSubscriptionOverride, setSplitSubscriptionOverride] = useState(null);
    const [isReactivateModalOpen, setIsReactivateModalOpen] = useState(false);
    const [reactivateDate, setReactivateDate] = useState(dayjs().add(5, 'day'));
    const [extendedDate, setExtendedDate] = useState(
        voucher?.invoice?.due_date ? dayjs(voucher.invoice.due_date).add(5, 'day') : dayjs()
    );

    useEffect(() => {
        console.log('PaymentData:----', paymentData);

    }, [paymentData])

    const getCompanyDataById = async () => {
        try {
            const res = await fetch(BASE_URL + `company/${company_id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await res.json();
            console.log('Company Data Response:', data);
            setCompanyData(data);
        } catch (error) {
            console.error('Error fetching company data:', error);
        }
    }

    useEffect(() => {
        if (company_id) {
            getCompanyDataById();
        }
    }, [company_id]);

    useEffect(() => {
        const sessionStr = sessionStorage.getItem('user-info');
        if (sessionStr) {
            const session = JSON.parse(sessionStr);
            setRole(session.user.role)
            setCompanyID(session.user.company_id)
            setLocationID(session.user.location_id)
            setMemberID(session.user.member_id)
            setUserId(session.user._id)
        }
        else {
            navigate('/login');
        }
    }, [])

    useEffect(() => {

        // DO NOT delete this code its important for paypro integration

        // const url = window.location.href;
        // const urlParams = new URLSearchParams(new URL(url).search);
        // const ordId = urlParams.get('ordId');
        // console.log(ordId);

        // if(ordId) {
        //     handleChangeVoucherStatus(ordId)
        // }
        if (role) {
            getVoucherById()
            getAllPackages()
            getLatestTransaction()
            getFacilities()
        }
        // const status = urlParams.get('status');
        // const msg = urlParams.get('msg');
    }, [role])

    useEffect(() => {
        if (voucher) {
            if (!voucher?.invoice?.due_date) {
                setDueDate(null);
                setToday(new Date());
                return;
            }
            const parsedDueDate = new Date(voucher.invoice.due_date);
            parsedDueDate.setHours(0, 0, 0, 0);
            setDueDate(parsedDueDate);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            setToday(currentDate);
            console.log("Due Date:", dueDate);
            console.log("Today:", today);
            console.log('dates comparison: ', dueDate && today && today <= dueDate);

            // Set discount defaults
            if (isDiscountModalOpen) {
                setDiscountAmount(voucher?.invoice?.discount || 0);
                setDiscountRemarksState(voucher?.invoice?.discount_remarks || '');
            }

            // Set extend date default
            if (isExtendModalOpen && voucher?.invoice?.due_date) {
                setExtendedDate(dayjs(voucher.invoice.due_date).add(5, 'day'));
            }

            // Set reactivation date default (today + 5 days)
            if (isReactivateModalOpen) {
                setReactivateDate(dayjs().add(5, 'day'));
            }
        }
    }, [voucher, isDiscountModalOpen, isExtendModalOpen, isReactivateModalOpen]);

    // Fetch subscription row when split modal opens but embedded subscription lacks start/end (common from list APIs).
    useEffect(() => {
        if (!isSplitModalOpen || !voucher) return;
        const sub = voucher.subscription_id;
        const sid =
            sub && typeof sub === 'object' && sub._id
                ? String(sub._id)
                : sub
                  ? String(sub)
                  : null;
        if (!sid) return;
        const embeddedHasPeriod =
            sub &&
            typeof sub === 'object' &&
            sub.start_date &&
            sub.end_date;
        if (embeddedHasPeriod) {
            setSplitSubscriptionOverride(null);
            return;
        }
        let cancelled = false;
        fetch(`${BASE_URL}subscription/get-subscription/${sid}`)
            .then((r) => r.json())
            .then((data) => {
                if (cancelled || !data?.subscription) return;
                setSplitSubscriptionOverride(data.subscription);
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, [isSplitModalOpen, voucher?.subscription_id]);

    // Auto-fill installment due dates when split modal opens or N changes — do not depend on full `voucher`
    // (avoids wiping user edits whenever getVoucherById refreshes).
    useEffect(() => {
        if (!isSplitModalOpen) return;
        const n = Math.max(2, Math.floor(Number(numberOfInstallments) || 0));
        const { start, end } = getSubscriptionPeriod();
        if (!start || !end) {
            setInstallmentDueDates(Array(n).fill(null));
            setSplitDateError(
                'Subscription start/end date is missing; cannot auto-fill due dates. Loading…'
            );
            return;
        }
        const today = dayjs().startOf('day');
        if (end.isBefore(today, 'day')) {
            setInstallmentDueDates(Array(n).fill(null));
            setSplitDateError(
                'Membership end date has already passed; installments cannot be created.'
            );
            return;
        }
        const spreadStart = start.isBefore(today) ? today : start;
        const next = computeAutoInstallmentDueDates(spreadStart, end, n);
        setInstallmentDueDates(next);
        setSplitDateError(validateInstallmentDueDates(next, end));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSplitModalOpen,
        numberOfInstallments,
        splitSubscriptionOverride,
        voucher?.subscription_id?.start_date,
        voucher?.subscription_id?.end_date,
        voucher?.subscription_id?._id,
    ]);

    useEffect(() => {
        if (!isSplitModalOpen || splitAmountMode !== 'custom' || !voucher) return;
        const n = Math.max(2, Math.floor(Number(numberOfInstallments) || 0));
        const equal = computeInstallmentShares(splitPrincipalAmount(), n);
        setSplitCustomAmounts(equal.map(String));
        setSplitAmountError(
            validateInstallmentAmounts(equal.map(String), splitPrincipalAmount(), n)
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSplitModalOpen, splitAmountMode, numberOfInstallments, voucher?._id]);

    function getVoucherById() {
        fetch(BASE_URL + `voucher/getVoucherById/${id}`)
            .then(async (response) => {
                const data = await response.json();
                if (!response.ok || !data?.voucher) {
                    setLoading(false);
                    return;
                }
                try {
                    const other_charges = JSON.parse(data.voucher?.invoice?.other_charges);
                    data.voucher.invoice.other_charges = other_charges;
                } catch {
                    // other_charges may already be an object or null
                }
                setVoucher(data.voucher);

                // Prefer populated member from voucher (works without members:read).
                const populatedMember =
                    data.voucher.member_id && typeof data.voucher.member_id === "object"
                        ? data.voucher.member_id
                        : null;
                if (populatedMember) {
                    setMember(populatedMember);
                    const packageId =
                        populatedMember.package_id?._id || populatedMember.package_id;
                    if (packageId) {
                        getMemberPackage(packageId);
                    } else {
                        setLoading(false);
                    }
                }

                const memberId = populatedMember?._id || data.voucher.member_id;
                // Soft enrichment: richer company/location populate when permitted.
                if (memberId) {
                    getMemberByID(memberId, { soft: Boolean(populatedMember) });
                } else if (!populatedMember) {
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    }
    const getLatestTransaction = () => {
        fetch(BASE_URL + `transaction/get-transactions-by-voucher-id/${id}`)
            .then((response) => response.json())
            .then((data) => {
                setTransaction(data.transaction[0])
            })
            .catch((error) => console.log(error));
    }
    function getAllPackages() {
        fetch(BASE_URL + `package/getPackages`)
            .then(async (response) => {
                const data = await response.json().catch(() => ({}));
                setPackages(response.ok ? data.packages || [] : []);
            })
            .catch((error) => {
                console.log(error);
                setPackages([]);
            });
    }

    function getMemberByID(memberId, { soft = false } = {}) {
        if (!memberId) {
            if (!soft) setLoading(false);
            return;
        }
        fetch(BASE_URL + `members/get-member/${memberId}`)
            .then(async (response) => {
                const data = await response.json();
                if (!response.ok || !data.member) {
                    // Soft mode: voucher already has member; ignore permission/API failures.
                    if (!soft) setLoading(false);
                    return;
                }
                setMember(data.member);
                const packageId = data.member.package_id?._id || data.member.package_id;
                if (packageId) {
                    getMemberPackage(packageId);
                } else if (!soft) {
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                if (!soft) setLoading(false);
            });
    }

    function getMemberPackage(packageId) {
        if (!packageId) {
            setLoading(false);
            return;
        }
        fetch(BASE_URL + `package/getPackageById/${packageId}`)
            .then(async (response) => {
                const data = await response.json();
                if (response.ok && data.packages) {
                    setMemberPackageAmount(data.packages);
                }
            })
            .catch((error) => console.log(error))
            .finally(() => setLoading(false));
    }

    // function getMemberPackage(id) {
    //     setLoading(true);

    //     fetch(BASE_URL + `package/getPackageById/${id}`)
    //       .then((response) => response.json())
    //       .then((data) => {
    //         if (!data.packages) {
    //           console.error("Package not found");
    //           setLoading(false);
    //           return;
    //         }

    //         setMemberPackageAmount(data.packages);

    //         const facilityIds = data.packages.facilities._id || []; 
    //         if (facilityIds.length === 0) {
    //           setFacilities([]); 
    //           setLoading(false);
    //           return;
    //         }


    //         setFacilities(facilityIds);
    //         setLoading(false);
    //       })
    //       .catch((error) => {
    //         console.error("Error fetching package:", error);
    //         setLoading(false);
    //       });
    // }

    async function getFacilities() {

        if (!role) return;
        let endpoint = '';
        console.log(role);
        if (role === 'SuperAdmin') {
            endpoint = 'facility/getPackageFacilities';
        } else if (role === 'Admin') {
            endpoint = `facility/getPackageFacilityByCompanyId/${company_id}`;
        } else if (role === 'ClubAdmin') {
            endpoint = `facility/getPackageFacilityByLocationId/${location_id}`;
        } else if (isDynamicStaffRole(role)) {
            endpoint = `facility/getPackageFacilityByLocationId/${location_id}`;
        }
        await fetch(BASE_URL + endpoint)
            .then((response) => response.json())
            .then((data) => {
                setFacilities(data.packageFacilities)

            })
            .catch((error) => console.log(error));
    }

    function getFamilyMembers(member_id) {
        fetch(BASE_URL + `familyMembers/getAllFamilyMembersByMemberId/${member_id}`)
            .then((response) => response.json())
            .then((data) => {
                setFamilyMembers(data.familyMembers);
                //   data.familyMembers.map((member) => {
                //     getFamilyMemberPackage(member.package_id)
                //   })
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const formatCardNumber = (value) => {
        // Remove all non-digit characters
        const cleaned = value.replace(/\D+/g, '');

        // Insert a dash after every 4 digits, but don't add one at the end
        const formatted = cleaned.match(/.{1,4}/g)?.join('-') || '';

        return formatted;
    };

    const handleNumberInputChange = (e) => {
        let { value } = e.target;
        const cursorPosition = e.target.selectionStart; // Get cursor position

        // Save the position of the cursor in the raw string
        const rawValue = value.replace(/-/g, ''); // Remove dashes to get the raw value

        // Format the number
        value = formatCardNumber(rawValue);

        // Update state with formatted value
        setCardNumber(value);

        // Adjust cursor position after formatting
        const newCursorPosition = cursorPosition + (value.split('-').length - 1);
        e.target.setSelectionRange(newCursorPosition, newCursorPosition);
    };

    const handlePayVoucher = async () => {

        // Do NOT DELETE this commented code , its imortant for pay pro integration

        const data = {
            invoice_no: voucher?.invoice_no,
        };
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };

        try {
            const response = await fetch(BASE_URL + `voucher/init_payment`, requestOptions);

            console.log('Response status:', response.status);
            if (!response.ok) {
                console.error('Response not ok:', response);
            } else {
                const responseData = await response.json();
                console.log('Response data:', responseData);
                console.log(responseData.data[1].Click2Pay);
                if (responseData.data[1].Click2Pay) {
                    const url = responseData.data[1].Click2Pay + `&callback_url=http://103.141.229.97/voucher/${voucher?._id}`;
                    window.open(url, '_blank');
                }
            }
        } catch (error) {
            console.error('Caught error:', error);
        }
    }

    const isVoucherAlreadyPaid = (v = voucher) => isVoucherSettled(v);

    const canStartPayVoucher = () => {
        return !buttonLoading &&
            !payVoucherSubmitLockRef.current &&
            !payVoucherCompletedRef.current &&
            !isVoucherAlreadyPaid();
    };

    const payMethodOptions = allowedVoucherPaymentMethods(getSessionUser());
    const defaultPayMethod = defaultVoucherPaymentMethod(payMethodOptions);

    const handleOpenPayVoucherModal = () => {
        if (!canStartPayVoucher()) return;
        if (!defaultPayMethod) return;
        setPaymentData((prev) => ({
            ...prev,
            payment_method: defaultPayMethod,
        }));
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        if (buttonLoading || payVoucherSubmitLockRef.current) return;
        setIsModalOpen(false)
        resetFields()
    }
    const getPrintTimestamp = () => {
        return dayjs().format("MMM DD, YYYY hh:mm:ss A");
    };


    // const  handleChangeVoucherStatus = async (order_id) => {
    //     const data = {
    //         paypro_id: order_id,
    //     }
    //     const requestOptions = {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify(data),
    //     };

    //     try {
    //         const response = await fetch(BASE_URL + `voucher/updatePaymentStatus`, requestOptions);

    //         console.log('Response status:', response.status);
    //         if (!response.ok) {
    //             console.error('Response not ok:', response);                
    //         } else {
    //             const responseData = await response.json();
    //             console.log('Response data:', responseData);
    //             getVoucherById()
    //             setIsPopupOpen(true)
    //             setTimeout(()=> {
    //                 setIsPopupOpen(false)
    //             }, 3000)
    //         }
    //     } catch (error) {
    //         console.error('Caught error:', error);
    //     }      
    // }


    const handleReactivateVoucher = async () => {
        setButtonLoading(true);
        if (!reactivateDate || !dayjs.isDayjs(reactivateDate) || !reactivateDate.isValid()) {
            setAlertType('error');
            setMessage('Please select a valid new end date.');
            setIsPopupOpen(true);
            setButtonLoading(false);
            setTimeout(() => setIsPopupOpen(false), 3000);
            return;
        }
        if (reactivateDate.startOf('day').valueOf() <= dayjs().startOf('day').valueOf()) {
            setAlertType('error');
            setMessage('New end date must be in the future.');
            setIsPopupOpen(true);
            setButtonLoading(false);
            setTimeout(() => setIsPopupOpen(false), 3000);
            return;
        }

        try {
            const response = await fetch(BASE_URL + `voucher/reactivate/${voucher._id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ new_end_date: reactivateDate.toISOString() }),
            });
            const responseData = await response.json();

            if (!response.ok) {
                setAlertType('error');
                setMessage(responseData.message || 'Failed to reactivate voucher.');
                setIsReactivateModalOpen(false);
                setIsPopupOpen(true);
                setTimeout(() => setIsPopupOpen(false), 3000);
            } else {
                setLoading(true);
                setAlertType('success');
                setMessage(responseData.message || 'Voucher reactivated successfully.');
                getVoucherById();
                setIsReactivateModalOpen(false);
                setIsPopupOpen(true);
                setTimeout(() => setIsPopupOpen(false), 3000);
            }
        } catch (error) {
            console.error('Error reactivating voucher:', error);
            setAlertType('error');
            setMessage('Failed to reactivate voucher.');
            setIsPopupOpen(true);
            setTimeout(() => setIsPopupOpen(false), 3000);
        } finally {
            setButtonLoading(false);
        }
    };

    const handleExtendDueDate = async () => {
        setButtonLoading(true)
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ new_due_date: extendedDate })
        };

        try {
            const response = await fetch(BASE_URL + `voucher/extendDueDate/${voucher._id}/${user_id}`, requestOptions);

            console.log('Response status:', response.status);
            if (!response.ok) {
                console.error('Response not ok:', response);
                const responseData = await response.json();
                setAlertType('error')
                setMessage(responseData.message)
                setIsExtendModalOpen(false)
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 3000)
            } else {
                const responseData = await response.json();
                console.log('Response data:', responseData);
                setLoading(true)
                setAlertType('success')
                setMessage(responseData.message)
                getVoucherById()
                setIsExtendModalOpen(false)
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 3000)
            }
        } catch (error) {
            console.error('Caught error:', error);
        } finally {
            setButtonLoading(false);
        }
    }



    const handleChangeVoucherStatus = async () => {
        if (payVoucherSubmitLockRef.current || buttonLoading || payVoucherCompletedRef.current) return;
        if (isVoucherAlreadyPaid()) {
            setAlertType('success')
            setMessage('Voucher already paid')
            setIsModalOpen(false)
            resetFields()
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 3000)
            getVoucherById()
            return;
        }
        payVoucherSubmitLockRef.current = true;
        setButtonLoading(true)
        if (discount > voucher?.invoice?.pending_amount) {
            // Handle case where discount exceeds pending amount
            setIsPopupOpen(true)
            setAlertType('error')
            setMessage('Discount cannot exceed pending amount')
            setButtonLoading(false);
            payVoucherSubmitLockRef.current = false;
            return;
        }
        const data = {
            id: voucher._id,
            payment_method: paymentData.payment_method,
            payment_status: paymentData.payment_type,
            reference_number: paymentData.reference_number,
            amount: paymentData.payment_type === 'Paid' ? voucher?.invoice?.pending_amount : paymentData.amount,
            discount: discount,
            discount_remarks: discountRemarks,
        }
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };

        try {
            const response = await fetch(BASE_URL + `voucher/updatePaymentStatus`, requestOptions);

            console.log('Response status:', response.status);
            if (!response.ok) {
                console.error('Response not ok:', response);
                const responseData = await response.json();
                setAlertType('error')
                setMessage(responseData.message + (responseData.machineMessage ? ` - Machine Response: ${responseData.machineMessage}` : ''))
                setIsModalOpen(false)
                resetFields()
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 3000)
                payVoucherSubmitLockRef.current = false;
            } else {
                const responseData = await response.json();
                console.log('Response data:', responseData);
                payVoucherCompletedRef.current = true;
                setLoading(true)
                setAlertType('success')
                setMessage(responseData.message + (responseData.machineMessage ? ` - Machine Response: ${responseData.machineMessage}` : ''))
                getVoucherById()
                setIsModalOpen(false)
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 3000)
            }
        } catch (error) {
            console.error('Caught error:', error);
            payVoucherSubmitLockRef.current = false;
        } finally {
            setButtonLoading(false);
        }
    }

    const handleApplyDiscount = async () => {
        setButtonLoading(true)
        if (Number(discountAmount) > (voucher?.invoice?.total_amount || 0)) {
            setIsPopupOpen(true)
            setAlertType('error')
            setMessage('Discount cannot exceed total amount')
            setButtonLoading(false);
            return;
        }

        const data = {
            voucher_id: voucher._id,
            discount: Number(discountAmount),
            discount_remarks: discountRemarksState,
        }

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };

        try {
            const response = await fetch(BASE_URL + `voucher/apply-discount`, requestOptions);

            if (!response.ok) {
                const responseData = await response.json();
                setAlertType('error')
                setMessage(responseData.message)
                setIsDiscountModalOpen(false)
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 3000)
            } else {
                const responseData = await response.json();
                setLoading(true)
                setAlertType('success')
                setMessage(responseData.message)
                getVoucherById()
                setIsDiscountModalOpen(false)
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 3000)
            }
        } catch (error) {
            console.error('Error applying discount:', error);
            setAlertType('error')
            setMessage('Failed to apply discount')
            setIsPopupOpen(true)
        } finally {
            setButtonLoading(false);
        }
    }

    const computeInstallmentShares = (total, n) => {
        const safeTotal = Number(total) || 0;
        const safeN = Math.max(2, Math.floor(Number(n) || 0));
        const base = Math.floor(safeTotal / safeN);
        const last = safeTotal - base * (safeN - 1);
        const shares = [];
        for (let i = 0; i < safeN; i++) {
            shares.push(i === safeN - 1 ? last : base);
        }
        return shares;
    };

    const validateInstallmentAmounts = (amountStrings, targetTotal, n) => {
        if (!Array.isArray(amountStrings) || amountStrings.length !== n) {
            return `Enter an amount for each of the ${n} installments.`;
        }
        let sum = 0;
        for (let i = 0; i < amountStrings.length; i++) {
            const val = Number(amountStrings[i]);
            if (!Number.isFinite(val) || val <= 0) {
                return `Installment #${i + 1} amount must be greater than zero.`;
            }
            sum += val;
        }
        const target = Number(targetTotal) || 0;
        if (Math.abs(sum - target) > 0.009) {
            return `Installment amounts must sum to ${target} (outstanding pending); current sum is ${sum}.`;
        }
        return '';
    };

    const getSplitDisplayAmounts = () => {
        const n = Math.max(2, Math.floor(Number(numberOfInstallments) || 0));
        const principal = splitPrincipalAmount();
        if (splitAmountMode === 'custom') {
            return Array.from({ length: n }, (_, i) => {
                const raw = splitCustomAmounts[i];
                const num = Number(raw);
                return Number.isFinite(num) ? num : 0;
            });
        }
        return computeInstallmentShares(principal, n);
    };

    /** Effective subscription for split: populated voucher.subscription_id, or fetched override. */
    const getEffectiveSubscriptionForSplit = () => {
        const embedded = voucher?.subscription_id;
        if (
            embedded &&
            typeof embedded === 'object' &&
            embedded.start_date &&
            embedded.end_date
        ) {
            return embedded;
        }
        return splitSubscriptionOverride;
    };

    /** Pull subscription start/end for installment scheduling. */
    const getSubscriptionPeriod = () => {
        const sub = getEffectiveSubscriptionForSplit();
        if (!sub) return { start: null, end: null };
        const start = sub.start_date ? dayjs(sub.start_date).startOf('day') : null;
        const end = sub.end_date ? dayjs(sub.end_date).startOf('day') : null;
        return { start, end };
    };

    const normalizeInstallmentDate = (d) => {
        if (d == null) return null;
        const jd = dayjs(d);
        return jd.isValid() ? jd.startOf('day') : null;
    };

    /** Mirror backend computeAutoInstallmentDueDates: spread N due dates evenly across [start, end]. */
    const computeAutoInstallmentDueDates = (start, end, n) => {
        const safeN = Math.max(2, Math.floor(Number(n) || 0));
        if (!start || !end) return Array(safeN).fill(null);
        const startMs = start.valueOf();
        const endMs = end.valueOf();
        if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || endMs <= startMs) {
            return Array(safeN).fill(null);
        }
        const stepMs = (endMs - startMs) / safeN;
        const dates = [];
        for (let i = 0; i < safeN; i++) {
            if (i === safeN - 1) {
                dates.push(dayjs(endMs));
            } else {
                dates.push(dayjs(startMs + Math.floor(stepMs * (i + 1))));
            }
        }
        return dates;
    };

    /** Validate user-edited dueDates the same way the backend does. Returns '' on success. */
    const validateInstallmentDueDates = (dates, subEnd) => {
        if (!Array.isArray(dates) || dates.length < 2) return 'At least 2 installments are required.';
        const todayKey = dayjs().startOf('day').valueOf();
        const seen = new Set();
        for (let i = 0; i < dates.length; i++) {
            const jd = normalizeInstallmentDate(dates[i]);
            if (!jd) return `Installment #${i + 1} has an invalid date.`;
            const k = jd.valueOf();
            if (i === 0 && k < todayKey) return 'First installment due date cannot be in the past.';
            if (seen.has(k)) return 'Installment due dates must be unique (no duplicate days).';
            seen.add(k);
            if (i > 0) {
                const prevJd = normalizeInstallmentDate(dates[i - 1]);
                if (!prevJd) return `Installment #${i} has an invalid date.`;
                if (k <= prevJd.valueOf()) {
                    return 'Installment due dates must be in strictly ascending order.';
                }
            }
            if (subEnd && k > subEnd.startOf('day').valueOf()) {
                return `Installment due date #${i + 1} cannot be after the membership end date.`;
            }
        }
        return '';
    };

    /** Prefer flag from voucher payload (from API enricher); fallback to company GET — avoids race / stale company fetch. */
    const isInstallmentsFeatureEnabled = () =>
        !!(voucher?.allow_voucher_installments ?? companyData?.allow_voucher_installments);

    /**
     * Split is allowed on full outstanding pending (no payments on voucher yet).
     * pending may differ from total_amount (e.g. admin "create voucher" adds member balance into pending).
     */
    const canSplitThisVoucher = () => {
        if (role === 'User') return false;
        if (!voucher || voucher.voucher_type !== 'Invoice') return false;
        if (voucher.is_active !== true) return false;
        if (voucher.is_split === true) return false;
        if (voucher.parent_voucher_id) return false;
        if ((voucher.paid_amount || 0) > 0) return false;
        if (!isInstallmentsFeatureEnabled()) return false;
        const inv = voucher.invoice;
        if (!inv || inv.is_paid === true) return false;
        if (!inv.due_date) return false;
        const pending = Number(inv.pending_amount ?? 0);
        const total = Number(inv.total_amount ?? 0);
        if (pending <= 0 || total <= 0) return false;
        return true;
    };

    const splitPrincipalAmount = () =>
        Number(voucher?.invoice?.pending_amount ?? voucher?.invoice?.total_amount ?? 0);

    const handleSplitVoucher = async () => {
        setButtonLoading(true);
        const n = Math.floor(Number(numberOfInstallments) || 0);
        if (!Number.isInteger(n) || n < 2) {
            setAlertType('error');
            setMessage('Number of installments must be an integer of 2 or more.');
            setIsPopupOpen(true);
            setButtonLoading(false);
            setTimeout(() => setIsPopupOpen(false), 3000);
            return;
        }

        const { end } = getSubscriptionPeriod();
        const dateError = validateInstallmentDueDates(installmentDueDates, end);
        if (dateError) {
            setAlertType('error');
            setMessage(dateError);
            setSplitDateError(dateError);
            setIsPopupOpen(true);
            setButtonLoading(false);
            setTimeout(() => setIsPopupOpen(false), 3000);
            return;
        }

        const dueDatesIso = installmentDueDates.map((d) => {
            const jd = normalizeInstallmentDate(d);
            return jd ? jd.toISOString() : null;
        });
        if (dueDatesIso.length !== n || dueDatesIso.some((x) => !x)) {
            setAlertType('error');
            setMessage('Every installment must have a valid due date.');
            setIsPopupOpen(true);
            setButtonLoading(false);
            setTimeout(() => setIsPopupOpen(false), 3000);
            return;
        }

        const principal = splitPrincipalAmount();
        let payloadAmounts;
        if (splitAmountMode === 'custom') {
            const amountErr = validateInstallmentAmounts(splitCustomAmounts, principal, n);
            if (amountErr) {
                setSplitAmountError(amountErr);
                setAlertType('error');
                setMessage(amountErr);
                setIsPopupOpen(true);
                setButtonLoading(false);
                setTimeout(() => setIsPopupOpen(false), 3000);
                return;
            }
            payloadAmounts = splitCustomAmounts.map((a) => Number(a));
        }

        try {
            const response = await fetch(BASE_URL + `voucher/split/${voucher._id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    numberOfInstallments: n,
                    dueDates: dueDatesIso,
                    ...(payloadAmounts ? { amounts: payloadAmounts } : {}),
                }),
            });
            const responseData = await response.json();

            if (!response.ok) {
                setAlertType('error');
                setMessage(responseData.message || 'Failed to split voucher.');
                setIsSplitModalOpen(false);
                setIsPopupOpen(true);
                setTimeout(() => setIsPopupOpen(false), 3000);
            } else {
                setLoading(true);
                setAlertType('success');
                setMessage(responseData.message || 'Voucher split successfully.');
                getVoucherById();
                setIsSplitModalOpen(false);
                setIsPopupOpen(true);
                setTimeout(() => setIsPopupOpen(false), 3000);
            }
        } catch (error) {
            console.error('Error splitting voucher:', error);
            setAlertType('error');
            setMessage('Failed to split voucher.');
            setIsPopupOpen(true);
            setTimeout(() => setIsPopupOpen(false), 3000);
        } finally {
            setButtonLoading(false);
        }
    };

    const formatExpiryDate = (value) => {
        // Remove all non-digit characters
        const cleaned = value.replace(/\D+/g, '');

        // Format as MM/YY, but don't exceed 5 characters
        if (cleaned.length <= 2) {
            return cleaned;
        }
        return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}`;
    };

    const validateExpiryDate = (value) => {
        // Check if the expiry date is in MM/YY format
        if (!/^\d{2}\/\d{2}$/.test(value)) {
            return 'Expiry date must be in MM/YY format';
        }

        const [month, year] = value.split('/').map(Number);

        // Validate month (must be between 01 and 12)
        if (month < 1 || month > 12) {
            return 'Invalid month. Must be between 01 and 12.';
        }

        // Validate year (must not be in the past)
        const currentYear = new Date().getFullYear() % 100; // Get last 2 digits of current year
        const currentMonth = new Date().getMonth() + 1; // Get current month (0-based, so +1)

        if (year < currentYear || (year === currentYear && month < currentMonth)) {
            return 'Expiry date cannot be in the past.';
        }

        return '';
    };

    const handleExpiryInputChange = (e) => {
        const { value } = e.target;

        // Format the value as MM/YY
        const formattedValue = formatExpiryDate(value);

        // Validate the formatted value
        const validationError = validateExpiryDate(formattedValue);

        // Update state
        setExpiryDate(formattedValue);
        setExpiryError(validationError);
    };

    const handleCvcInputChange = (e) => {
        let { value } = e.target;

        // Ensure that only numbers are entered, and restrict to 3 digits max
        if (/^\d{0,3}$/.test(value)) {
            setCvc(value);
            setCvcError(''); // Clear any previous errors
        } else {
            setCvcError('CVC must be a 3-digit number.');
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        setIsModalOpen(false)
        resetFields()
        setIsPopupOpen(true)
        setTimeout(() => {
            setIsPopupOpen(false)
        }, 3000)
    }

    const printVoucher = () => {
        window.print()
    }

    const resetFields = () => {
        setCardNumber('')
        setExpiryDate('')
        setCvc('')
        setCardName('')
        setPaymentData({
            payment_method: defaultVoucherPaymentMethod(allowedVoucherPaymentMethods(getSessionUser())) || 'Cash',
            payment_type: 'Paid',
            amount: 0
        })
    }
    const handleNavigate = (id) => {
        navigate(`/vouchers/${voucher.subscription_id._id}`);
    };




    return (
        <>



            {
                loading ? (
                    
                        <div className="flex justify-center items-center mt-20 relative">
                            {/* SVG Gradient Definition */}
                            <svg width="0" height="0">
                                <defs>
                                    <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor="#D71920" />
                                        <stop offset="100%" stopColor="#F7931E" />
                                    </linearGradient>
                                </defs>
                            </svg>

                            {/* Circular Progress with Gradient Stroke */}
                            <CircularProgress
                                thickness={4}
                                size={35}
                                sx={{
                                    'svg circle': {
                                        stroke: 'url(#gradientColors)', // Apply gradient stroke
                                    },
                                }}
                            />
                        </div>
                    
                ) : (
                    <div className='px-2 md:px-2 md:text-[16px] lg:px-10 lg:mb-16 print:p-0 print:m-0'>
                        {/* Sticky staff actions — outside printRef so bank layout scroll does not hide Pay */}
                        <div className='sticky top-0 z-10 bg-gx-canvas flex justify-between items-center p-2 print:hidden sm:text-base xl:text-4xl border-b border-gx-border mb-2'>
                            <div className='px-2 py-2'>
                                <IoArrowBack onClick={handleNavigate}
                                    className="cursor-pointer text-4xl print:hidden" />
                            </div>
                            <div className='flex items-center gap-4'>
                                {
                                    voucher?.invoice && !isVoucherAlreadyPaid() && voucher?.is_active === true && role !== 'User' && !voucher?.is_split && !payVoucherCompletedRef.current && (
                                        <div className='flex gap-2 text-sm flex-wrap'>
                                            {dueDate && today && today <= dueDate && voucher.member_id && !voucher.member_id.is_new && hasPermission(getSessionUser(), 'subscriptions:extend_due_date') && (
                                                <span className='bg-blue-700 p-2 px-4 text-white font-bold rounded-full hover:cursor-pointer'
                                                    onClick={() => setIsExtendModalOpen(true)}
                                                >Extend Due Date</span>
                                            )}
                                            {hasPermission(getSessionUser(), 'subscriptions:pay_voucher') && (
                                            <span className={`bg-green-700 p-2 px-4 text-white font-bold rounded-full ${buttonLoading ? 'opacity-60 pointer-events-none' : 'hover:cursor-pointer'}`}
                                                onClick={handleOpenPayVoucherModal}
                                                aria-disabled={buttonLoading}
                                            >Pay Invoice</span>
                                            )}
                                            {hasPermission(getSessionUser(), 'subscriptions:apply_discount') && (
                                            <span className='bg-gx-orange p-2 px-4 text-white font-bold rounded-full hover:cursor-pointer'
                                                onClick={() => setIsDiscountModalOpen(true)}
                                            >Apply Discount</span>
                                            )}
                                            {canSplitThisVoucher() && hasPermission(getSessionUser(), 'subscriptions:split_voucher') && (
                                                <span className='bg-purple-700 p-2 px-4 text-white font-bold rounded-full hover:cursor-pointer'
                                                    onClick={() => {
                                                        setNumberOfInstallments(2);
                                                        setSplitSubscriptionOverride(null);
                                                        setSplitDateError('');
                                                        setInstallmentDueDates([]);
                                                        setSplitAmountMode('equal');
                                                        setSplitCustomAmounts([]);
                                                        setSplitAmountError('');
                                                        setIsSplitModalOpen(true);
                                                    }}
                                                >Split into Installments</span>
                                            )}
                                        </div>
                                    )
                                }
                                {voucher?.is_split && (
                                    <span className='bg-gx-navy p-2 px-4 text-white font-bold rounded-full text-sm'>
                                        Split into installments
                                    </span>
                                )}
                                {voucher?.parent_voucher_id && voucher?.installment_index && voucher?.total_installments && (
                                    <span className='bg-purple-100 text-purple-800 p-2 px-4 font-bold rounded-full text-sm'>
                                        Installment {voucher.installment_index} of {voucher.total_installments}
                                    </span>
                                )}
                                <IoMdPrint className='text-2xl hover:cursor-pointer md:text-4xl lg:text-4xl' onClick={() => reactToPrintFn()} />
                            </div>
                        </div>
                        <div ref={printRef}>
                        <BankVoucherLayout
                            company_id={company_id}
                            voucherData={{
                                invoice_no: voucher?.invoice_no,
                                voucher_no: voucher?.invoice_no,
                                voucher_type: voucher?.voucher_type,
                                voucher_date: voucher?.voucher_date,
                                due_date: voucher?.invoice?.due_date,
                                registration_fee: voucher?.invoice?.registration_fee,
                                membership_fee: voucher?.invoice?.membership_fee,
                                trainer_fee: voucher?.invoice?.trainer_fee,
                                facilities_fee: voucher?.invoice?.facilities_fee,
                                other_charges_amount: voucher?.invoice?.other_charges?.amount,
                                other_charges_name: voucher?.invoice?.other_charges?.name,
                                discount: voucher?.invoice?.discount,
                                package_name: member_package_amount?.title,
                                is_paid: voucher?.invoice?.is_paid,
                                payment_status: voucher?.invoice?.payment_status,
                                payment_date: voucher?.invoice?.payment_date,
                                reference_number: voucher?.reference_number,
                                payment_method: voucher?.payment_method,
                                invoice: voucher?.invoice,
                                total_amount: voucher?.invoice?.total_amount,
                                pending_amount: voucher?.invoice?.pending_amount
                            }}
                            companyData={companyData}
                            memberData={{
                                member_id: member?.member_id,
                                name: member?.name,
                                phone: member?.phone,
                                package_name: member_package_amount?.title
                            }}
                        >


                            <div className='border-b-2 mb-10 flex justify-between items-center print:mx-0'>
                                <img src={companyData && companyData?.company_logo ? encodedImagesURI(companyData?.company_logo) : logo} alt='' className='text-center p-2 w-24 md:w-28 lg:w-32 lg:p-4 xl:w-40' style={{ objectFit: 'contain', maxHeight: '170px' }}></img>
                                {
                                    isVoucherAlreadyPaid() && (
                                        <div className=''>
                                            <img src={paid1} alt='' />
                                        </div>
                                    )
                                }
                            </div>

                            <div className='flex justify-between items-start mx-[11px] text-[8px] gap-4 print:mx-5 print:my-16 md:mx-4 md:text-sm md:gap-10 lg:text-sm xl:text-md xl:text-xl print:text-lg'>
                                <div className='w-1/3'>
                                    <p><strong className='mr-2'>From:</strong>{member?.company_id?.company_name}</p>
                                    <p><strong className='mr-2'>Address:</strong>{member?.location_id?.address}</p>
                                    <p><strong className='mr-2'>Email:</strong>{member?.location_id?.email}</p>
                                    <p><strong className='mr-2'>Phone No:</strong>{member?.location_id?.phone_number}</p>
                                    <p><strong className='mr-2'>Package Duration:</strong>{member_package_amount?.isFinite === true ? `${member_package_amount?.durationInDays} days` : member_package_amount?.duration}</p>



                                </div>
                                <div className='w-1/3'>
                                    <p ><strong className='mr-2 '>To:</strong>{member?.name}</p>
                                    <p><strong className='mr-2'>Address: </strong>{member?.address}</p>
                                    {/* <p><strong>CNIC: </strong>{member?.doc_number}</p> */}
                                    <p><strong className='mr-2'>Phone No: </strong>{member?.phone}</p>
                                    <p><strong className='mr-2'>Email: </strong>{member?.email}</p>
                                    <p><strong className='mr-2'>Package Name:</strong>{member_package_amount?.title}</p>
                                    <p><strong className='mr-2'>Member ID:</strong>{member?.member_id}</p>

                                </div>
                                <div className='w-1/3'>
                                    <p>
                                        <strong className="mr-2">Invoice Date: </strong>
                                        {voucher?.voucher_date
                                            ? dayjs(voucher.voucher_date).format("MMM DD, YYYY")
                                            : ''}
                                    </p>

                                    <p><strong className='mr-2'>Invoice No:</strong>{voucher?.invoice_no}</p>
                                    {voucher?.company_has_bank_integration === true && (
                                        <p>
                                            <strong className='mr-2'>Bank Voucher Number:</strong>
                                            {voucher?.transaction_number || 'N/A'}
                                        </p>
                                    )}
                                    <p>
                                        <strong className="mr-2">Due Date: </strong>
                                        {voucher?.invoice?.due_date
                                            ? dayjs(voucher.invoice.due_date).format("MMM DD, YYYY")
                                            : ''}
                                    </p>

                                    <p>
                                        <strong className="mr-2">Subscription Valid Till: </strong>
                                        {(voucher?.invoice?.billing_period_end ||
                                            voucher?.subscription_id?.end_date)
                                            ? dayjs(
                                                voucher?.invoice?.billing_period_end ||
                                                    voucher.subscription_id.end_date
                                            ).format("MMM DD, YYYY")
                                            : ''}
                                    </p>
                                    {voucher?.invoice?.payment_date && (
                                        <p>
                                            <strong className="mr-2">Paid Date:</strong>
                                            {dayjs(voucher.invoice.payment_date).format("MMM DD, YYYY")}
                                        </p>
                                    )}
                                    <p>
                                        <strong className="mr-2">Subscription Start Date: </strong>
                                        {(voucher?.invoice?.billing_period_start ||
                                            voucher?.subscription_id?.renewed_date)
                                            ? dayjs(
                                                voucher?.invoice?.billing_period_start ||
                                                    voucher.subscription_id.renewed_date
                                            ).format("MMM DD, YYYY")
                                            : ''}
                                    </p>






                                </div>
                            </div>
                            <div className=' mt-10 print:mt-16 print:mb-5 mx-4 print:mx-5 font-bold text-[8px] md:text-sm lg:text-sm xl:text-xl print:text-lg '>Charges:</div>
                            <div className='text-left mx-10 my-5 print:mx-5 '>
                                <table className='w-full'>
                                    <tbody className='text-[8px] md:text-sm lg:text-sm xl:text-xl print:text-lg'>
                                        {
                                            voucher?.invoice?.membership_fee > 0 && (
                                                <tr className='border-b-2' >
                                                    <td className='py-2'>Membership Fee</td>
                                                    <td className='py-2'>{voucher?.invoice?.membership_fee}</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            voucher?.invoice?.registration_fee > 0 && (
                                                <tr className='border-b-2' >
                                                    <td className='py-2'>Registration Fee</td>
                                                    <td className='py-2'>{voucher?.invoice?.registration_fee}</td>
                                                </tr>
                                            )
                                        }

                                        {
                                            voucher?.invoice?.trainer_fee > 0 && (
                                                <tr className='border-b-2' >
                                                    <td className='py-2'>Trainer Fee({(voucher?.trainer_id?.name)})</td>
                                                    <td className='py-2'>{voucher?.invoice?.trainer_fee}</td>
                                                </tr>
                                            )
                                        }
                                        {voucher?.invoice?.trainer_fee === 0 ? (facilities
                                            .filter(facility => member_package_amount?.facilities?.includes(facility._id))
                                            .map(facility => (
                                                <tr key={facility._id} className='border-b-2'>
                                                    <td className='py-2'>{facility.name}</td>
                                                    <td className='py-2'>{facility.fee === 0 ? 'Complimentary Discount' : facility.fee}</td>
                                                </tr>
                                            ))) : null
                                        }
                                        {
                                            voucher?.invoice?.other_charges !== null && (
                                                <tr className='border-b-2' >
                                                    <td className='py-2'>{voucher?.invoice?.other_charges.name}</td>
                                                    <td className='py-2'>{voucher?.invoice?.other_charges.amount}</td>
                                                </tr>
                                            )
                                        }

                                    </tbody>
                                </table>
                            </div>
                            <div className=' print:mt-16 print:mx-20 mx-0  flex flex-row flex justify-between text-[8px] md:text-base lg:text-sm print:text-lg xl:text-xl'>
                                <div className='flex flex-col mt-10 mx-12'>
                                    <div className='flex items-center sm:gap-0 text-[8px] md:text-sm lg:text-sm xl:text-xl print:text-lg'>
                                        <h1 className='font-bold p-2 '>Payment Methods:</h1>
                                        <p>{voucher?.payment_method || (voucher?.invoice?.is_paid ? 'Bank' : 'N/A')}</p>
                                    </div>
                                    {
                                        voucher?.payment_method && voucher?.payment_method !== 'Cash' && (
                                            <div className='flex items-center sm:gap-0 text-[8px] md:text-sm lg:text-sm xl:text-xl print:text-lg'>
                                                <h1 className='font-bold p-2 '>Payment Reference:</h1>
                                                <p>{voucher?.reference_number || 'N/A'}</p>
                                            </div>
                                        )
                                    }

                                    {(discountRemarks || voucher?.invoice?.discount_remarks) && (
                                        <div className='flex items-center sm:gap-0 text-[8px] md:text-sm lg:text-sm xl:text-xl print:text-lg'>
                                            <h1 className='font-bold p-2'>Discount Remarks:</h1>
                                            <p>{discountRemarks || voucher?.invoice?.discount_remarks || <span className='text-gx-ink-soft'>No Discount Remarks</span>}</p>
                                        </div>
                                    )}
                                </div>
                                <div className='text-[8px] pr-4 md:text-sm lg:text-sm lg:pr-20 xl:text-xl xl:pr-28 print:text-lg'>
                                    <table className='mt-5 w-full '>
                                        <tr className='border-b-2'>
                                            <td className='pb-2 font-bold pr-10'>Subtotal:</td>
                                            <td className='pb-2'>{voucher?.invoice?.total_amount}</td>
                                        </tr>
                                        <tr className='border-b-2'>
                                            <td className='pb-2 font-bold pr-10'>Discount:</td>
                                            <td className='pb-2'>{voucher?.invoice?.discount}</td>
                                        </tr>
                                        <tr className='border-b-2'>
                                            <td className='font-bold pt-2'>Total:</td>
                                            <td className='pt-2'>{voucher?.invoice?.total_amount}</td>
                                        </tr>



                                        {
                                            isVoucherAlreadyPaid() ?
                                                <tr className='border-b-2'>
                                                    <td className='font-bold pt-2'>Paid:</td>
                                                    <td className='pt-2'>{voucher?.paid_amount || 0}</td>
                                                </tr> :
                                                <>
                                                    <tr className='border-b-2'>
                                                        <td className='font-bold pt-2'>Balance:</td>
                                                        <td className='pt-2'>{transaction?.balance_before || 0}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='font-bold pt-2'>Pending:</td>
                                                        <td className='pt-2'>{voucher?.invoice?.pending_amount}</td>
                                                    </tr>
                                                </>
                                        }
                                        {/* <tr className='border-b-2'>
                    <td className='font-bold pt-2'>Discount Remarks</td>
                    <td className='pt-2'>{member?.discount_remarks}</td>
                </tr> */}


                                    </table>

                                </div>

                            </div>
                            <div className='print:block hidden text-left text-[8px] text-black-500 mt-4 md:text-sm lg:text-sm xl:text-xl print:text-lg'>
                                Printed on: {getPrintTimestamp()}
                            </div>
                        </BankVoucherLayout>
                        </div>
                    </div >
                )
            }

            {/* <CustomModal isModal={isModalOpen} handleModal={() => setIsModalOpen(false)} size={'2xl'}>
        <form onSubmit={handleSubmit} className='m-10 text-gx-ink-soft'>
            <div className='flex justify-between gap-5 mt-5'>
                <div className='w-full'>
                    <label className=''>Name on Card:</label>
                    <img alt='' src={master} className='h-5 float-right'/>
                    <img alt='' src={visa} className='h-5 float-right'/>
                    <input type='text' name='name' placeholder='Name' 
                    value={cardName}
                    onChange={(e)=>setCardName(e.target.value)}
                     className='p-2 border w-full rounded-lg'/>
                </div>
            </div>
            <div className='flex justify-between gap-5 mt-5'>
                <div className='w-full'>
                    <label className=''>Card Number:</label>
                    <input type='text' name='cardNumber' placeholder='Card Number'
                     value={cardNumber}
                     onChange={handleNumberInputChange}
                     maxLength="19"
                     className='p-2 border w-full rounded-lg'/>
                </div>
                <div className='w-full'>
                    <label className=''>Expiry Date:</label>
                    <input type='text' name='expiry' placeholder='Expiry Date (MM/YY)'
                        value={expiryDate}
                        onChange={handleExpiryInputChange}
                        className='p-2 border w-full rounded-lg'
                        maxLength="5"/>
                        {expiryError && <p className="text-red-500">{expiryError}</p>}
                </div>
                <div className='w-full'>
                    <label className=''>CVC:</label>
                    <input type='text' name='cvc' placeholder='CVC'
                    value={cvc}
                    onChange={handleCvcInputChange} 
                    className='p-2 border w-full rounded-lg'
                    maxLength='3'/>
                    {cvcError && <p className="text-red-500">{cvcError}</p>}
                </div>
            </div>
            <div>
                <button className='py-2 m-5 px-10 float-right bg-[#C30000] text-white rounded-full hover:bg-[#db0000]'>Pay</button>
            </div>
        </form>
    </CustomModal> */}

            <CustomModal isModal={isModalOpen} handleModal={handleModalClose} size={'xl'}>
                <form onSubmit={async(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!canStartPayVoucher()) return;
                    if (!payMethodOptions.includes(paymentData.payment_method)) {
                        alert('You do not have permission to use this payment method.');
                        return;
                    }
                    if ((paymentData.payment_method !== 'Cash') && !paymentData.reference_number) {
                        alert('Reference number is required!');
                        return;
                    }
                    await handleChangeVoucherStatus();
                }}>
                    <div className='pt-5'></div>
                    <div className='m-5 p-2 flex justify-center gap-10 text-gx-ink-soft border border-gx-border rounded-lg font-bold'>
                        <div className='flex justify-start items-center gap-2'>
                            <h1>Name:</h1>
                            <p className='font-semibold	'>{member?.name}</p>
                        </div>
                        <div className='flex justify-start items-center gap-2'>
                            <h1>Amount:</h1>
                            {/* IF Discount exist add slash on original pending amount and show amount subracted with discount */}
                            {discount > 0 ? (
                                <>
                                    <p className="text-sm text-gx-ink-soft line-through font-semibold"> {voucher?.invoice?.pending_amount}</p>

                                    <p className='font-semibold'>{voucher?.invoice?.pending_amount - discount} </p>
                                </>
                            ) : (
                                <p className='font-semibold'>{voucher?.invoice?.pending_amount}</p>
                            )}
                        </div>
                    </div>
                    <div className='mx-4 md:mx-7 text-gx-ink-soft flex flex-col gap-4'>

                        {/* Payment Method */}
                        <div className='flex flex-col w-full gap-2'>
                            <label className='font-bold'>Payment Method:</label>
                            {payMethodOptions.length === 0 ? (
                                <p className='text-sm text-red-600'>You do not have permission to use a payment method.</p>
                            ) : (
                            <select
                                className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
                                value={paymentData.payment_method}
                                disabled={buttonLoading}
                                onChange={(e) => setPaymentData({ ...paymentData, payment_method: e.target.value })}
                            >
                                {VOUCHER_PAYMENT_METHODS.filter((method) => payMethodOptions.includes(method.value)).map((method) => (
                                    <option key={method.value} value={method.value}>{method.label}</option>
                                ))}
                            </select>
                            )}
                        </div>

                        {/* Reference Number (Conditional) */}
                        {(paymentData.payment_method !== 'Cash') && (
                            <div className='flex flex-col w-full gap-2'>
                                <label className='font-bold'>Reference Number <span className="text-red-500">*</span>:</label>
                                <input
                                    type='text'
                                    required
                                    className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
                                    placeholder='Enter reference number'
                                    value={paymentData.reference_number || ''}
                                    disabled={buttonLoading}
                                    onChange={(e) =>
                                        setPaymentData({ ...paymentData, reference_number: e.target.value })
                                    }
                                />
                            </div>
                        )}
                        {/* Discount */}
                        <div className='flex flex-col w-full gap-2'>
                            <label className='font-bold'>Discount:</label>
                            <input
                                type='number'
                                className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
                                placeholder='Enter discount amount'
                                value={discount}
                                disabled={buttonLoading}
                                onChange={(e) => setDiscount(e.target.value)}
                            />
                        </div>

                        {/* Add Discount Remark */}
                        <div className='flex flex-col w-full gap-2'>
                            <label className='font-bold'>Discount Remarks:</label>
                            <input
                                type='text'
                                className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
                                placeholder='Enter discount remarks'
                                value={discountRemarks}
                                disabled={buttonLoading}
                                onChange={(e) => setDiscountRemarks(e.target.value)}
                            />
                        </div>

                    </div>

                    {/* <div className='flex justify-between items-center my-5 mx-7 text-gx-ink-soft '>
            <div className='w-1/2 font-bold'>Payment Type: </div>
            <div className='w-1/2 flex gap-10 justify-start items-center font-semibold'>
                <div className='flex gap-2'>
                    <input type='radio' name='payment_type'
                           value='Paid'
                           checked={paymentData.payment_type === 'Paid'}
                           onChange={(e) => setPaymentData({...paymentData, payment_type: e.target.value})}
                    />
                    <label>Full</label>
                </div>
                <div className='flex gap-2'>
                    <input type='radio' name='payment_type'
                           value='Partial'
                           checked={paymentData.payment_type === 'Partial'}
                           onChange={(e) => setPaymentData({...paymentData, payment_type: e.target.value})}
                    />
                    <label>Partial</label>
                </div>
            </div>
        </div>
        {
            paymentData.payment_type === 'Partial' && (
                <div className='mx-7 text-gx-ink-soft flex justify-between items-center '>
                    <label className='font-bold w-1/2'>Amount:</label>
                    <input type='number' 
                           className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
                           value={paymentData.amount}
                           onChange={(e) => setPaymentData({...paymentData, amount: e.target.value})}
                           />
                </div>
            )
        } */}

                    <div className='sticky bottom-0 bg-gx-surface border-t border-gx-border m-0 p-5 text-center'>
                        <div className='flex justify-end text-center items-center gap-3'>
                            <button
                                type="submit"
                                className='flex w-full text-center justify-center bg-blue-900 p-2 px-6 border border-gx-border rounded-lg text-white font-medium hover:bg-blue-800 disabled:opacity-60 disabled:pointer-events-none disabled:cursor-not-allowed'
                                disabled={buttonLoading || payVoucherCompletedRef.current || payMethodOptions.length === 0 || !hasPermission(getSessionUser(), 'subscriptions:pay_voucher')}
                                aria-disabled={buttonLoading || payVoucherCompletedRef.current || payMethodOptions.length === 0}
                                onClick={(e) => {
                                    if (!canStartPayVoucher() || payMethodOptions.length === 0 || !hasPermission(getSessionUser(), 'subscriptions:pay_voucher')) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }}
                            >
                                {buttonLoading ? 'Processing...' : 'Pay Voucher'}
                                {buttonLoading && (
                                    <div className='ml-2 mt-1'><CircularProgress size={20} color='#fff' /></div>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </CustomModal>

            <LocalizationProvider dateAdapter={AdapterDayjs}>

                <CustomModal isModal={isExtendModalOpen} handleModal={() => setIsExtendModalOpen(false)} size={'xl'}>
                    <h2 className="m-5 text-center text-xl font-medium text-gx-ink-soft">Extend Voucher Due Date?</h2>

                    <div className='mx-10 p-2 text-gx-ink-soft border border-gx-border rounded-lg font-bold'>
                        <div className='flex justify-between gap-10'>
                            <div className='flex justify-start items-center gap-2'>
                                <h1>Due Date:</h1>
                                <p className='font-semibold'>
                                    {voucher?.invoice?.due_date ? dayjs(voucher.invoice.due_date).format("MMM DD, YYYY") : ''}
                                </p>
                            </div>

                            <div className='flex flex-col gap-1'>
                                <h1>Extended Due Date:</h1>
                                <DatePicker
                                    value={extendedDate}
                                    onChange={(date) => setExtendedDate(date)}
                                    minDate={voucher?.invoice?.due_date ? dayjs(voucher.invoice.due_date) : dayjs()}
                                    className="border p-2 rounded-lg text-gx-ink"
                                    format="MMM DD, YYYY"
                                />
                            </div>
                        </div>

                        <div className='flex py-2 justify-start items-center gap-2'>
                            <h1>Name:</h1>
                            <p className='font-semibold'>{member?.name}</p>
                        </div>
                    </div>

                    <div className='m-5 text-center'>
                        <p className="text-gx-ink-soft mt-3">Are you sure you want to extend this voucher due date?</p>
                        <div className='flex justify-center items-center gap-3 my-5'>
                            <button
                                className={`bg-green-600 p-2 px-8 border border-gx-border rounded-lg text-white font-medium hover:bg-green-700 ${buttonLoading ? 'cursor-not-allowed bg-gray-400 hover:bg-gray-700' : ''}`}
                                onClick={handleExtendDueDate}
                                disabled={buttonLoading}
                            >
                                Yes
                                {buttonLoading && (
                                    <div className='ml-2 mt-1'><CircularProgress size={20} color='#fff' /></div>
                                )}
                            </button>

                            <button
                                className='bg-red-600 p-2 px-8 border border-gx-border rounded-lg text-white font-medium hover:bg-red-700'
                                onClick={() => setIsExtendModalOpen(false)}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </CustomModal>
            </LocalizationProvider>

            <CustomModal isModal={isDiscountModalOpen} handleModal={() => setIsDiscountModalOpen(false)} size={'xl'}>
                <h2 className="m-5 text-center text-xl font-medium text-gx-ink-soft">Apply/Adjust Discount</h2>
                <div className='mx-10 p-4 border border-gx-border rounded-lg'>
                    <div className='flex flex-col gap-3 text-gx-ink-soft'>
                        <div className='flex justify-between items-center bg-gx-canvas p-2 rounded'>
                            <span className='font-bold text-sm'>Total Amount:</span>
                            <span className='font-semibold'>{voucher?.invoice?.total_amount}</span>
                        </div>
                        <div className='flex justify-between items-center bg-gx-canvas p-2 rounded'>
                            <span className='font-bold text-sm'>Existing Discount:</span>
                            <span className='font-semibold text-red-600'>- {voucher?.invoice?.discount || 0}</span>
                        </div>
                        <div className='flex justify-between items-center bg-gx-canvas p-2 rounded'>
                            <span className='font-bold text-sm'>Current Pending:</span>
                            <span className='font-semibold'>{voucher?.invoice?.pending_amount}</span>
                        </div>

                        <div className='border-t border-gx-border my-2'></div>

                        <div className='flex flex-col gap-2'>
                            <label className='font-bold'>Set New Total Discount:</label>
                            <input
                                type='number'
                                className='font-semibold border border-blue-400 w-full p-2 rounded-lg outline-0 focus:ring-2 focus:ring-blue-200'
                                value={discountAmount}
                                onChange={(e) => setDiscountAmount(e.target.value)}
                            />
                            <p className='text-xs text-gx-ink-soft italic'>* This will replace the previous discount amount.</p>
                        </div>

                        <div className='flex justify-between items-center bg-green-50 p-3 rounded border border-green-200 mt-2'>
                            <span className='font-bold text-green-800'>New Pending Amount (Preview):</span>
                            <span className='font-bold text-green-800 text-lg'>
                                {Math.max(0, (voucher?.invoice?.pending_amount || 0) - (Number(discountAmount) - (voucher?.invoice?.discount || 0)))}
                            </span>
                        </div>

                        <div className='flex flex-col gap-2 mt-2'>
                            <label className='font-bold'>Discount Remarks:</label>
                            <input
                                type='text'
                                className='font-semibold border border-gx-border w-full p-2 rounded-lg outline-0'
                                placeholder='Reason for discount'
                                value={discountRemarksState}
                                onChange={(e) => setDiscountRemarksState(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className='m-5 text-center'>
                    <div className='flex justify-center items-center gap-3 my-5'>
                        <button className={`bg-green-600 p-2 px-8 border border-gx-border rounded-lg text-white font-medium hover:bg-green-700 ${buttonLoading ? 'cursor-not-allowed bg-gray-400' : ''}`}
                            onClick={handleApplyDiscount}
                            disabled={buttonLoading}
                        >
                            Apply
                            {buttonLoading && (
                                <div className='ml-2 mt-1'><CircularProgress size={20} color='#fff' /></div>
                            )}
                        </button>
                        <button className='bg-red-600 p-2 px-8 border border-gx-border rounded-lg text-white font-medium hover:bg-red-700' onClick={() => setIsDiscountModalOpen(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            <CustomModal
                isModal={isSplitModalOpen}
                handleModal={() => {
                    setIsSplitModalOpen(false);
                    setSplitSubscriptionOverride(null);
                    setSplitDateError('');
                    setSplitAmountMode('equal');
                    setSplitCustomAmounts([]);
                    setSplitAmountError('');
                }}
                size={'xl'}
            >
                <h2 className="m-5 text-center text-xl font-medium text-gx-ink-soft">Split Voucher into Installments</h2>
                <div className='mx-10 p-4 border border-gx-border rounded-lg'>
                    <div className='flex flex-col gap-3 text-gx-ink-soft'>
                        <div className='flex justify-between items-center bg-gx-canvas p-2 rounded'>
                            <span className='font-bold text-sm'>Voucher No:</span>
                            <span className='font-semibold'>{voucher?.invoice_no}</span>
                        </div>
                        <div className='flex justify-between items-center bg-gx-canvas p-2 rounded'>
                            <span className='font-bold text-sm'>Invoice total (fees):</span>
                            <span className='font-semibold'>{voucher?.invoice?.total_amount}</span>
                        </div>
                        <div className='flex justify-between items-center bg-gx-canvas p-2 rounded border border-gx-border'>
                            <span className='font-bold text-sm'>Outstanding to split (pending):</span>
                            <span className='font-semibold'>{voucher?.invoice?.pending_amount}</span>
                        </div>
                        <div className='flex justify-between items-center bg-gx-canvas p-2 rounded'>
                            <span className='font-bold text-sm'>Subscription period:</span>
                            <span className='font-semibold'>
                                {(() => {
                                    const { start, end } = getSubscriptionPeriod();
                                    if (!start || !end) return 'Missing — cannot split';
                                    return `${start.format('MMM DD, YYYY')} → ${end.format('MMM DD, YYYY')}`;
                                })()}
                            </span>
                        </div>

                        <div className='border-t border-gx-border my-2'></div>

                        <div className='flex flex-col gap-2'>
                            <label className='font-bold'>Number of Installments (min 2):</label>
                            <input
                                type='number'
                                min={2}
                                step={1}
                                className='font-semibold border border-blue-400 w-full p-2 rounded-lg outline-0 focus:ring-2 focus:ring-blue-200'
                                value={numberOfInstallments}
                                onChange={(e) => setNumberOfInstallments(e.target.value)}
                            />
                            <label className='font-bold mt-2'>Amount split mode:</label>
                            <div className='flex flex-wrap gap-4'>
                                <label className='flex items-center gap-2 cursor-pointer'>
                                    <input
                                        type='radio'
                                        name='splitAmountModeDetail'
                                        checked={splitAmountMode === 'equal'}
                                        onChange={() => {
                                            setSplitAmountMode('equal');
                                            setSplitAmountError('');
                                        }}
                                    />
                                    <span className='text-sm'>Divide equally</span>
                                </label>
                                <label className='flex items-center gap-2 cursor-pointer'>
                                    <input
                                        type='radio'
                                        name='splitAmountModeDetail'
                                        checked={splitAmountMode === 'custom'}
                                        onChange={() => setSplitAmountMode('custom')}
                                    />
                                    <span className='text-sm'>Custom amounts</span>
                                </label>
                            </div>
                            <p className='text-xs text-gx-ink-soft italic'>
                                {splitAmountMode === 'equal'
                                    ? '* Equal mode: the last installment absorbs any rounding so the total stays exact.'
                                    : '* Custom mode: enter each installment amount; the sum must equal the outstanding pending amount.'}
                            </p>
                            <p className='text-xs text-gx-ink-soft italic'>
                                * Due dates auto-fill across the subscription period; override any row to customize.
                            </p>
                        </div>

                        <div className='mt-2'>
                            <h3 className='font-bold mb-2'>Preview:</h3>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <table className='w-full border border-gx-border rounded'>
                                    <thead className='bg-gx-canvas'>
                                        <tr>
                                            <th className='text-left p-2 text-sm'>Installment</th>
                                            <th className='text-left p-2 text-sm'>Amount</th>
                                            <th className='text-left p-2 text-sm'>Due Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getSplitDisplayAmounts().map((share, i, arr) => {
                                            const { end } = getSubscriptionPeriod();
                                            const minD = dayjs().startOf('day');
                                            // Avoid minDate > maxDate (MUI greys out every day) when end is before today
                                            const maxD =
                                                end && end.isValid() && !end.endOf('day').isBefore(minD, 'day')
                                                    ? end.endOf('day')
                                                    : undefined;
                                            const raw = installmentDueDates[i];
                                            const value =
                                                raw != null ? normalizeInstallmentDate(raw) : null;
                                            const principal = splitPrincipalAmount();
                                            return (
                                                <tr key={i} className='border-t border-gx-border'>
                                                    <td className='p-2 text-sm'>{i + 1} of {arr.length}</td>
                                                    <td className='p-2 text-sm'>
                                                        {splitAmountMode === 'custom' ? (
                                                            <input
                                                                type='number'
                                                                min={1}
                                                                step={1}
                                                                className='w-full border border-blue-300 rounded p-1 text-sm'
                                                                value={splitCustomAmounts[i] ?? ''}
                                                                onChange={(e) => {
                                                                    const nInst = Math.max(
                                                                        2,
                                                                        Math.floor(
                                                                            Number(numberOfInstallments) || 0
                                                                        )
                                                                    );
                                                                    const next = Array.from(
                                                                        { length: nInst },
                                                                        (_, j) =>
                                                                            j < splitCustomAmounts.length
                                                                                ? splitCustomAmounts[j]
                                                                                : ''
                                                                    );
                                                                    next[i] = e.target.value;
                                                                    setSplitCustomAmounts(next);
                                                                    setSplitAmountError(
                                                                        validateInstallmentAmounts(
                                                                            next,
                                                                            principal,
                                                                            nInst
                                                                        )
                                                                    );
                                                                }}
                                                            />
                                                        ) : (
                                                            share
                                                        )}
                                                    </td>
                                                    <td className='p-2 text-sm align-top'>
                                                        <div className='min-w-[220px]'>
                                                            <DatePicker
                                                                value={value}
                                                                minDate={minD}
                                                                maxDate={maxD}
                                                                referenceDate={minD}
                                                                onChange={(d) => {
                                                                    const nInst = Math.max(
                                                                        2,
                                                                        Math.floor(
                                                                            Number(numberOfInstallments) || 0
                                                                        )
                                                                    );
                                                                    const next = Array.from(
                                                                        { length: nInst },
                                                                        (_, j) =>
                                                                            j < installmentDueDates.length
                                                                                ? installmentDueDates[j]
                                                                                : null
                                                                    );
                                                                    next[i] = d
                                                                        ? normalizeInstallmentDate(d)
                                                                        : null;
                                                                    setInstallmentDueDates(next);
                                                                    const { end: e } = getSubscriptionPeriod();
                                                                    setSplitDateError(
                                                                        validateInstallmentDueDates(next, e)
                                                                    );
                                                                }}
                                                                slotProps={{
                                                                    textField: {
                                                                        size: 'small',
                                                                        fullWidth: true,
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </LocalizationProvider>
                            {splitAmountMode === 'custom' && (
                                <p className='text-xs text-gx-ink-soft mt-2'>
                                    Total:{' '}
                                    <span className='font-semibold'>
                                        {getSplitDisplayAmounts().reduce((s, a) => s + a, 0)}
                                    </span>{' '}
                                    / {splitPrincipalAmount()} (outstanding)
                                </p>
                            )}
                            {splitDateError && (
                                <p className='text-xs text-red-600 mt-2 font-semibold'>{splitDateError}</p>
                            )}
                            {splitAmountError && (
                                <p className='text-xs text-red-600 mt-2 font-semibold'>{splitAmountError}</p>
                            )}
                        </div>
                    </div>
                </div>

                <div className='m-5 text-center'>
                    <div className='flex justify-center items-center gap-3 my-5'>
                        <button
                            className={`bg-purple-700 p-2 px-8 border border-gx-border rounded-lg text-white font-medium hover:bg-purple-800 ${buttonLoading || splitDateError || splitAmountError ? 'cursor-not-allowed bg-gray-400' : ''}`}
                            onClick={handleSplitVoucher}
                            disabled={buttonLoading || !!splitDateError || !!splitAmountError}
                        >
                            Split
                            {buttonLoading && (
                                <div className='ml-2 mt-1'><CircularProgress size={20} color='#fff' /></div>
                            )}
                        </button>
                        <button
                            className='bg-red-600 p-2 px-8 border border-gx-border rounded-lg text-white font-medium hover:bg-red-700'
                            onClick={() => setIsSplitModalOpen(false)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </CustomModal>

            <CustomModal isModal={isReactivateModalOpen} handleModal={() => setIsReactivateModalOpen(false)} size={'xl'}>
                <h2 className="m-5 text-center text-xl font-medium text-gx-ink-soft">Reactivate Voucher</h2>
                <div className='mx-10 p-4 border border-gx-border rounded-lg'>
                    <div className='flex flex-col gap-3 text-gx-ink-soft'>
                        <div className='flex justify-between items-center bg-gx-canvas p-2 rounded'>
                            <span className='font-bold text-sm'>Voucher No:</span>
                            <span className='font-semibold'>{voucher?.invoice_no}</span>
                        </div>
                        <div className='flex justify-between items-center bg-gx-canvas p-2 rounded'>
                            <span className='font-bold text-sm'>Current End Date:</span>
                            <span className='font-semibold'>
                                {voucher?.invoice?.due_date ? dayjs(voucher.invoice.due_date).format('MMM DD, YYYY') : '-'}
                            </span>
                        </div>

                        <div className='flex flex-col gap-2 mt-2'>
                            <label className='font-bold'>New End Date:</label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    value={reactivateDate}
                                    minDate={dayjs().add(1, 'day').startOf('day')}
                                    onChange={(d) => setReactivateDate(d)}
                                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                />
                            </LocalizationProvider>
                        </div>

                        {voucher?.is_split && (
                            <p className='text-xs text-amber-700 italic mt-2'>
                                * For installment vouchers, the new end date must be earlier than the next unpaid installment's due date. The last unpaid installment's due date will be updated to this new end date.
                            </p>
                        )}
                        <p className='text-gx-ink-soft mt-1 text-sm'>Are you sure you want to reactivate this voucher?</p>
                    </div>
                </div>

                <div className='m-5 text-center'>
                    <div className='flex justify-center items-center gap-3 my-5'>
                        <button
                            className={`bg-amber-600 p-2 px-8 border border-gx-border rounded-lg text-white font-medium hover:bg-amber-700 ${buttonLoading ? 'cursor-not-allowed bg-gray-400' : ''}`}
                            onClick={handleReactivateVoucher}
                            disabled={buttonLoading}
                        >
                            Reactivate
                            {buttonLoading && (
                                <div className='ml-2 mt-1'><CircularProgress size={20} color='#fff' /></div>
                            )}
                        </button>
                        <button
                            className='bg-red-600 p-2 px-8 border border-gx-border rounded-lg text-white font-medium hover:bg-red-700'
                            onClick={() => setIsReactivateModalOpen(false)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </CustomModal>

            {
                isPopupOpen ? (
                    <Popup alertType={alertType} message={message} onClose={() => setIsPopupOpen(false)} />
                ) : null
            }
        </>
    )
}

export default Voucher